/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileServiceGetFileLinkResponse
 */
export interface FileServiceGetFileLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof FileServiceGetFileLinkResponse
     */
    link?: string | null;
}

/**
 * Check if a given object implements the FileServiceGetFileLinkResponse interface.
 */
export function instanceOfFileServiceGetFileLinkResponse(value: object): value is FileServiceGetFileLinkResponse {
    return true;
}

export function FileServiceGetFileLinkResponseFromJSON(json: any): FileServiceGetFileLinkResponse {
    return FileServiceGetFileLinkResponseFromJSONTyped(json, false);
}

export function FileServiceGetFileLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileServiceGetFileLinkResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'link': json['link'] == null ? undefined : json['link'],
    };
}

export function FileServiceGetFileLinkResponseToJSON(json: any): FileServiceGetFileLinkResponse {
    return FileServiceGetFileLinkResponseToJSONTyped(json, false);
}

export function FileServiceGetFileLinkResponseToJSONTyped(value?: FileServiceGetFileLinkResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'link': value['link'],
    };
}

